export const CANCEL_TASK = 'cancel_task';
export const CANCEL_TASK_SUCCESSFUL = 'cancel_task_successfull';
export const CANCEL_TASK_FAILED = 'cancel_task_failed';



